// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"c9b85d6c","127":"b39865cd","149":"6e916198","266":"64bbd076","283":"f4b94d2a","302":"b92d8729","387":"920f2877","453":"848906bf","783":"7996b08b","812":"03eb21d4"}[chunkId] + ".chunk.js";
};